import { render } from "./ManageClientTasks.vue?vue&type=template&id=6900f183"
import script from "./ManageClientTasks.vue?vue&type=script&lang=js"
export * from "./ManageClientTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ManageClientTasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6900f183"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6900f183', __exports__)) {
    api.reload('6900f183', __exports__)
  }
  
  module.hot.accept("./ManageClientTasks.vue?vue&type=template&id=6900f183", () => {
    api.rerender('6900f183', render)
  })

}


export default __exports__